import { render, staticRenderFns } from "./create-scheme-form.vue?vue&type=template&id=1ba55559&"
import script from "./create-scheme-form.vue?vue&type=script&lang=js&"
export * from "./create-scheme-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports